const lang = {
    "Kep": "QES",
    "KepNotLinked": "η εγκεκριμένη υπογραφή σας δεν έχει συνδεθεί ακόμη με λογαριασμό. Συνδεθείτε κανονικά και θα τη συνδέσουμε.",
    "KepNewAccount": "Δεν έχετε λογαριασμό; Εγγραφή",
    "KepLinked": "Η εγκεκριμένη υπογραφή συνδέθηκε με τον λογαριασμό",
    "KepLinkFailed": "Δεν ήταν δυνατή η σύνδεση της εγκεκριμένης υπογραφής. Συνδεθείτε ξανά με αυτή και θα τη συνδέσουμε",
    "KepFile": "Αρχείο κλειδιού",
    "ErrorKepLogin": "Η σύνδεση με εγκεκριμένη υπογραφή απέτυχε",
    "EnterWidth": "Συνδέσου με:",
    "Registration": "Κανω ΕΓΓΡΑΦΗ",
    "enter": "Να ερθει μεσα",
    "EntrWidthEmailOrPhone": "Συνδεθείτε με email ή τηλέφωνο",
    "login": "Εξουσιοδότηση",
    "NoAkkGoReg": "Μητρώο",
    "Password": "Κωδικός πρόσβασης",
    "Name": "Ονομα",
    "LastName": "Επώνυμο",
    "Phone": "Για να εγγραφείτε, εισάγετε τον αριθμό τηλεφώνου σας",
    "Email": "Ταχυδρομείο",
    "RepeatPassword": "επανάληψη κωδικού πρόσβασης",
    "Сancel": "Ματαίωση",
    "Save": "Σώσει",
    "Language": "Γλώσσα",
    "ConfirmThisMail": "Το email σας επιβεβαιώθηκε",
    "Saved": "Αποθηκεύτηκε",
    "Error": "Λάθος",
    "FillInAllTheFields": "Συμπληρώστε όλα τα πεδία",
    "Next": "Περαιτέρω",
    "MinPassLength": "Ελάχιστο μήκος κωδικού πρόσβασης 4 χαρακτήρες",
    "ForgotYourPassword": "Ξεχάσατε τον κωδικό σας",
    "RestorePassword": "Παρακαλώ ορίστε έναν νέο κωδικό πρόσβασης.",
    "UserMustBeRegistered": "Ο χρήστης πρέπει να είναι εγγεγραμμένος",
    "Confirm": "Επιβεβαιώνω",
    "WrongFormat": "Λάθος μορφή",
    "WrongPassword": "Λάθος κωδικός",
    "WrongLoginOrPassword": "λάθος είσοδος ή κωδικός πρόσβασης",
    "PhoneAlreadyRegistered": "Το τηλέφωνο είναι ήδη καταχωρημένο",
    "EmailAlreadyRegistered": "Η αλληλογραφία έχει ήδη εγγραφεί",
    "FillInTheFieldsCorrectly": "Συμπληρώστε σωστά τα πεδία",
    "ThisAccountDoesNotExist": "Αυτός ο λογαριασμός δεν υπάρχει",
    "LinkIsNotValid": "Ο σύνδεσμος δεν είναι έγκυρος",
    "AMessageHasBeenSentToTheSpecifiedLogin": "Ένα μήνυμα έχει σταλεί στο καθορισμένο όνομα χρήστη",
    "IncorrectCaptcha": "Λάθος captcha",
    "CaptchaIsNotValid": "Το Captcha δεν είναι πλέον έγκυρο",
    "EnterCaptcha": "Εισαγάγετε captcha",
    "EnterSMS": "Εισαγάγετε κωδικό από SMS",
    "SMSCodeIsNoLongerValid": "Ο κωδικός SMS δεν είναι πλέον έγκυρος",
    "SMSCodeIsIncorrect": "Ο κωδικός SMS είναι λανθασμένος",
    "MailNotVerifiedLinkTimedOut": "Η αλληλογραφία δεν επιβεβαιώθηκε, ο σύνδεσμος έληξε",
    "DemoLogin": "Επίδειξη σύνδεσης",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "Είστε βέβαιοι ότι θέλετε να εισέλθετε στην <b> επίδειξη </b> για να τη δοκιμάσετε;",
    "FillInAdditionalInformation": "Συμπληρώστε επιπλέον πληροφορίες",
    "ToCompleteRegistration": "Για την ολοκλήρωση της εγγραφής",
    "LinkThirdPartyServices": "Σύνδεση υπηρεσιών τρίτων",
    "Complete": "Να ολοκληρωσω",
    "AccountAlreadyLinked": "Ο λογαριασμός είναι ήδη συνδεδεμένος",
    "AccountNotRegistered": "Ο λογαριασμός δεν είναι εγγεγραμμένος",
    "NotMyNumber": "Όχι ο αριθμός μου",
    "Back": "Πίσω",
    "numberOfAttemptsToCheckAuth": "Αριθμός προσπαθειών σύνδεσης:",
    "InvalidPassNumberOfAttemptsToCheckAuth": "Λάθος κωδικός πρόσβασης, αριθμός προσπαθειών σύνδεσης:",
    "TryAgainAfterMinute": "Παρακαλώ δοκιμάστε ξανά σε 2 λεπτά",
    "Help": "Υποστήριξη",
    "y": "Ναί",
    "n": "Δεν",
    "doYouConfirmEmail": "Είστε βέβαιοι ότι θέλετε να αλλάξετε το email σας;",
    "success": "Επιτυχώς",
    "goToAutorize": "Μεταβείτε στην εξουσιοδότηση",
    "UserEmailAlreadyExists": "Ο χρήστης με αυτό το email υπάρχει ήδη",
    "UserPhoneAlreadyExists": "Ο χρήστης με αυτόν τον αριθμό τηλεφώνου υπάρχει ήδη",
    "TermOfUse": "Οροι χρήσης",
    "PrivacyPolicy": "Πολιτική Απορρήτου",
    "accountNotRegistered": "ο λογαριασμός δεν είναι καταχωρημένος",
    "wantToReg": "Θα θέλατε να εγγραφείτε;",
    "weSuccessChangeYouEmail": "Αλλάξαμε με επιτυχία τη διεύθυνση email σας",
    "youCanCloseThisWindow": "Μπορείτε να κλείσετε αυτό το παράθυρο",
    "countryConfirm": "Επιβεβαίωση χώρας",
    "EmailAlreadyTied": "Η αλληλογραφία είναι ήδη συνδεδεμένη με άλλο λογαριασμό",
    "areYourCountry": "αυτή είναι η χώρα σας;",
    "EmergencyEntrance": "Παλαιά εξουσιοδότηση",
    "enterCorrectNumber": "εισάγετε τον αριθμό σε διεθνή μορφή",
    "thisPhoneRegister": "Αυτός ο αριθμός τηλεφώνου είναι ήδη καταχωρημένος στο σύστημα",
    "wantUsePhoneForAuth": "Θέλετε να συνδεθείτε χρησιμοποιώντας αυτόν τον αριθμό τηλεφώνου;",
    "ok": "ΕΝΤΑΞΕΙ",
    "regAgree": "Με την εγγραφή ενός λογαριασμού, αποδέχομαι",
    "wantBind": "Θέλετε να συνδεθείτε και να συνδέσετε την υπηρεσία",
    "bind": "δένω",
    "yoursMailBinded": "Το email σας βρίσκεται σε υπάρχοντα λογαριασμό",
    "wantUsePhoneAndBind": "έχουν ήδη εγγραφεί στο σύστημα",
    "notGetDataFromApple": "Αποτυχία λήψης δεδομένων από την Apple",
    "ErrorAppleLogin": "Σφάλμα εξουσιοδότησης μέσω Apple",
    "ErrorGoogleLogin": "Σφάλμα εξουσιοδότησης μέσω Google",
    "ErrorTelegramLogin": "Σφάλμα κατά τη σύνδεση μέσω Telegram",
    "ErrorFacebookLogin": "Σφάλμα σύνδεσης μέσω Facebook",
    "EMailOrPhone": "Εισαγάγετε έναν έγκυρο αριθμό τηλεφώνου ή διεύθυνση email.",
    "withoutName": "Κανένα όνομα",
    "goToCabinet": "Προς το γραφείο",
    "Logout": "Λήξη συνεδρίας",
    "creationDate": "Ημερομηνία δημιουργίας",
    "preparingCompany1": "Δημιουργούμε την εταιρεία σας, αφήστε μας ένα λεπτό...",
    "preparingCompany2": "Ετοιμάζουμε μια διεπαφή για τη διαχείριση αγαθών και υπηρεσιών...",
    "preparingCompany3": "Εργαζόμαστε για βολική χρηματοοικονομική λογιστική...",
    "preparingCompany4": "Κάνουμε τις τελικές ρυθμίσεις, σχεδόν έτοιμες...",
    "companyBlocked": "Αυτή η εταιρεία είναι ανενεργή",
    "youBlockedInComp": "Ο χρήστης δεν είναι ενεργός, η σύνδεση δεν είναι δυνατή",
    "loginTitle": "Όλα όσα χρειάζεται μια επιχείρηση σε ένα μέρος",
    "loginDescr": "Αυτοματοποίηση για καταστήματα, καφετέριες, υπηρεσίες παράδοσης, εστιατόρια, αποθήκες, παραγωγή ή υπηρεσίες",
    "NoAkkGoRegText": "Δεν έχετε λογαριασμό;",
    "LoginPlaceholder": "Παρακαλώ δώστε τις απαιτούμενες πληροφορίες",
    "loginText": "Έχετε ήδη λογαριασμό;",
    "and": "Και",
    "AcceptTheTerms": "Παρακαλώ αποδεχτείτε την πολιτική απορρήτου και τους όρους χρήσης",
    "CountryPhoneFormat": "Εάν αυτή δεν είναι η χώρα σας, βεβαιωθείτε ότι έχετε εισαγάγει τον αριθμό τηλεφώνου σας στη σωστή διεθνή μορφή.",
    "SaveNewPassword": "Αποθήκευση νέου κωδικού πρόσβασης"
}

export default function() {
    return lang;
}